<template>
  <div class="help padding_top">
    <p>关注医生可在【我要咨询】【专业医生】列表中，选择【我的关注】快速找到关注医生</p>
    <p><strong>第一步：</strong>登录状态下，在顶部菜单中点击<span class="orange">【专业医生】</span>，下方展示医生列表
    </p>
    <img src="../../../assets/userImg/followDoc_a.png" alt="">
    <p><strong>第二步：</strong>在【专业医生】页面列表中，点击想要关注医生的<span class="orange">【主页】</span>按钮，进入【医生主页】
    </p>
    <img src="../../../assets/userImg/followDoc_b.png" alt="" >
    <p><strong>第三步：</strong>在【医生主页】中，点击医生介绍中的<span class="orange">【关注TA】</span>按钮，关注医生成功
    </p>
    <img src="../../../assets/userImg/followDoc_c.png" alt="" >
    <p><strong>【未注册】</strong>在用户注册时，填写推荐医生的名字，注册完成后即默认关注该医生
    </p>
    <img src="../../../assets/userImg/followDoc_d.png" alt="">
    <p><strong>【查看关注医生】</strong></p>
    <p><strong>第一步：</strong>登录状态下，点击顶部菜单栏中的<span class="orange">【专业医生】</span>或<span class="orange">【我要咨询】</span>
    </p>
    <img src="../../../assets/img/userAppoint_a.png" alt="">
    <p><strong>第二步：</strong>在医生列表上方的筛选卡中，选择<span class="orange">【我的关注】</span>，即可查看关注医生，其中【我要咨询】下的医生只显示开放预约的医生
    </p>
    <strong class="orange">【专业医生】</strong>
    <img src="../../../assets/userImg/followDoc_e.png" alt="">
    <strong class="orange">【我要咨询】</strong>
    <img src="../../../assets/userImg/followDoc_f.png" alt="">
  </div>

</template>

<script>
export default {
  name: "followDoc",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
